import React, { useState } from 'react';
import axios from 'axios';

const API_URL = 'https://api.civilcadpro.in/api';
function UserActivity() {
  const [licenseId, setLicenseId] = useState('');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    if (!licenseId.trim()) return;
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/analytics/user/${licenseId.trim()}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setData(res.data);
    } catch (err) {
      alert('Error fetching data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 style={{ marginBottom: 25, color: '#1a1a2e' }}>User Activity</h2>

      <div className="card">
        <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
          <input
            type="text"
            placeholder="Enter License ID (LIC-XXXX)"
            value={licenseId}
            onChange={(e) => setLicenseId(e.target.value)}
            style={{
              flex: 1,
              padding: '12px 15px',
              border: '1px solid #ddd',
              borderRadius: 6,
              fontSize: 14
            }}
          />
          <button className="btn btn-primary" onClick={handleSearch} disabled={loading}>
            {loading ? 'Searching...' : 'Search'}
          </button>
        </div>
      </div>

      {data && (
        <>
          {/* Command Stats */}
          <div className="card">
            <h2>Command Usage</h2>
            <p style={{ color: '#888', marginBottom: 15 }}>
              Total commands: <strong>{data.totalCommands}</strong>
            </p>
            {data.commandStats.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#888' }}>No data</p>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Command</th>
                    <th>Times Used</th>
                  </tr>
                </thead>
                <tbody>
                  {data.commandStats.map(cmd => (
                    <tr key={cmd._id}>
                      <td><strong>{cmd._id}</strong></td>
                      <td>{cmd.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {/* Check-in History */}
          <div className="card">
            <h2>Check-in History</h2>
            {data.checkins.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#888' }}>No check-ins</p>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Date/Time</th>
                    <th>IP Address</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data.checkins.slice(0, 20).map(check => (
                    <tr key={check._id}>
                      <td>{new Date(check.timestamp).toLocaleString()}</td>
                      <td>{check.ipAddress || 'N/A'}</td>
                      <td>
                        <span className={`status-badge ${check.isValid ? 'status-approved' : 'status-rejected'}`}>
                          {check.isValid ? 'Valid' : 'Invalid'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {/* Recent Commands */}
          <div className="card">
            <h2>Recent Commands</h2>
            {data.recentUsage.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#888' }}>No recent usage</p>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Command</th>
                    <th>Date/Time</th>
                    <th>Session</th>
                  </tr>
                </thead>
                <tbody>
                  {data.recentUsage.slice(0, 30).map(use => (
                    <tr key={use._id}>
                      <td><strong>{use.commandName}</strong></td>
                      <td>{new Date(use.timestamp).toLocaleString()}</td>
                      <td style={{ fontFamily: 'monospace', fontSize: 11 }}>{use.sessionId}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default UserActivity;